module.exports = __webpack_public_path__ + "img/collection-weddingRingsFrameSettings.16b2c8d.webp";